import { render, staticRenderFns } from "./WebsiteAmenityCategory.vue?vue&type=template&id=6325f9cd&scoped=true&"
import script from "./WebsiteAmenityCategory.vue?vue&type=script&lang=js&"
export * from "./WebsiteAmenityCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6325f9cd",
  null
  
)

export default component.exports